import React from 'react';
import { getCNPJMask } from '../../utils/InputMaskUtils';
import MaskedInput from 'react-text-mask';

const CNPJMaskedInput = (props) => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={getCNPJMask()}
      placeholderChar={'\u2000'}
      showMask
    />
  );
};

export default CNPJMaskedInput;
